import React, { Component } from 'react';
import AlertsDrawer from './AlertsDrawer';
import {
  getUserAlerts,
  getUserAlertsNumber,
  acknowledgeUserAlerts,
  acknowledgeAllUserAlerts,
} from './AlertsDrawer.actions';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/NavigationWrapper';
import moment from 'moment';

class AlertsDrawerContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      notificationType: 0,
      notifications: [],
      alerts: [],
      next: {},
      totalNumberOfAlerts: 0,
    };

    this._onToggleAlertsDrawer = this._onToggleAlertsDrawer.bind(this);
    this._onChangeNotificationType = this._onChangeNotificationType.bind(this);
    this._onClickAlert = this._onClickAlert.bind(this);
    this._onClickAcknowledge = this._onClickAcknowledge.bind(this);
    this._onClickAcknowledgeAll = this._onClickAcknowledgeAll.bind(this);
    this._updateNotifications = this._updateNotifications.bind(this);
    this._onLoadMoreNotifications = this._onLoadMoreNotifications.bind(this);
    this._onClickClearAllNotifications = this._onClickClearAllNotifications.bind(this);
  }

  render() {
    return (
      <AlertsDrawer
        open={this.state.open}
        notifications={this.state.notifications}
        notificationsNumber={this.state.notifications.length}
        notificationType={this.state.notificationType}
        onToggleAlertsDrawer={this._onToggleAlertsDrawer}
        onChangeNotificationType={this._onChangeNotificationType}
        onClickAlert={this._onClickAlert}
        onClickAcknowledge={this._onClickAcknowledge}
        onClickAcknowledgeAll={this._onClickAcknowledgeAll}
        onLoadMoreNotifications={this._onLoadMoreNotifications}
        alerts={this.state.alerts}
        totalNumberOfAlerts={this.state.totalNumberOfAlerts}
        onClickClearAll={this._onClickClearAllNotifications}
      />
    );
  }

  componentDidMount() {
    this._getAlertsAndNotifications();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.notifications) !== JSON.stringify(this.props.notifications)) {
      this._updateNotifications(this.props.notifications);
    }
  }

  _getAlertsAndNotifications = () => {
    getUserAlerts().then((alerts) => {
      getUserAlertsNumber().then((number) => {
        let notifications = JSON.parse(localStorage.getItem('ui_notifications')) || [];
        this.setState({
          notifications: notifications,
          alerts:
            alerts.body != null && Array.isArray(alerts.body.SelectedAlerts)
              ? alerts.body.SelectedAlerts
              : [],
          next: alerts.body != null && alerts.body.NextAlert ? alerts.body.NextAlert : {},
          totalNumberOfAlerts: number.body,
          open: this.state.open && !(notifications.length == 0 && number.body == 0),
        });
      });
    });
  };

  _updateNotifications(newNotifications) {
    let notifications = this.state.notifications;
    let alerts = this.state.alerts;
    let alertsNr = this.state.totalNumberOfAlerts;

    if (newNotifications[0].type == 'alert') {
      alerts.unshift(newNotifications[0]);
      alertsNr = alertsNr + 1;
    } else if (newNotifications[0].type == 'ui_notification') {
      notifications.unshift(newNotifications[0]);
      localStorage.setItem('ui_notifications', JSON.stringify(notifications));
    }

    this.setState({
      notifications: notifications,
      alerts: alerts,
      totalNumberOfAlerts: alertsNr,
    });
  }

  _onLoadMoreNotifications(event) {
    if (this.state.alerts.length < this.state.totalNumberOfAlerts) {
      let next = this.state.next;
      if (next != {}) {
        getUserAlerts(next.rowKey).then((res) => {
          let oldAlerts = this.state.alerts;
          let newAlerts = res.body.SelectedAlerts;
          if (newAlerts && newAlerts.length > 0) {
            if (oldAlerts.find((el) => this._isSameAlert(el, newAlerts[0])) == undefined) {
              oldAlerts = oldAlerts.concat(newAlerts);
            }
          }

          this.setState({
            alerts: oldAlerts,
            next: res.body.NextAlert || {},
          });
        });
      }
    }
  }

  _isSameAlert(oldAlert, newAlert) {
    if (
      oldAlert.instrumentSerialNumber == newAlert.instrumentSerialNumber &&
      oldAlert.data.MessageType == newAlert.data.MessageType &&
      oldAlert.data.ReferenceDate == newAlert.data.ReferenceDate
    ) {
      return true;
    }
    return false;
  }

  _onToggleAlertsDrawer() {
    if (this.state.notifications.length || this.state.alerts.length) {
      this.setState({ open: !this.state.open });
    }
  }

  _onChangeNotificationType(event, index) {
    this.setState({ notificationType: index });
  }

  _onClickAlert(sn, referenceDate) {
    this.setState({ open: false });

    let startDate = moment(referenceDate)
      .utc()
      .second(0)
      .millisecond(0)
      .format('YYYY-MM-DDTHH:mm:ss[Z]');
    let endDate = moment(startDate).utc().add(24, 'h').format('YYYY-MM-DDTHH:mm:ss[Z]');

    this.props.navigate(
      `/instrument-details/${sn}/report-instrumentAlerts?EndDate=${endDate}&ReportName=instrumentAlerts&SelectedInstrument=${sn}&StartDate=${startDate}`,
      {
        replace: true,
      }
    );
  }

  _onClickAcknowledge(serialNumber, referenceDate, alertType) {
    acknowledgeUserAlerts(serialNumber, referenceDate, alertType).then(() => {
      let filteredAlerts = this.state.alerts.filter(
        (el) =>
          el.instrumentSerialNumber != serialNumber ||
          el.data.ReferenceDate != referenceDate ||
          el.data.MessageType != alertType
      );
      this.setState({
        alerts: filteredAlerts,
        totalNumberOfAlerts: this.state.totalNumberOfAlerts - 1,
      });
    });
  }

  _onClickAcknowledgeAll() {
    acknowledgeAllUserAlerts().then(() => {
      this.setState({
        alerts: [],
        next: {},
        totalNumberOfAlerts: 0,
        open: false,
      });
    });
  }

  _onClickClearAllNotifications() {
    localStorage.setItem('ui_notifications', null);
    this.setState({
      notifications: [],
      open: false,
    });
  }
}

const mapStateToProps = (state, props) => ({
  notifications: state.notifications.notifications || [],
});

export default withRouter(connect(mapStateToProps, {})(AlertsDrawerContainer));
